<p-floatlabel class="w-full" variant="on">
  <p-autocomplete
    [formControl]="control()"
    [suggestions]="filtered()"
    (completeMethod)="search($event)"
    [multiple]="true"
    [dropdown]="true"
    [typeahead]="false"
    [addOnBlur]="true"
    [invalid]="control().invalid && control().touched"
    appendTo="body"
    fluid
  >
    <ng-template let-email #item>
      {{ labelFor(email) }}
    </ng-template>
    <ng-template let-email #selecteditem>
      {{ labelFor(email) }}
    </ng-template>
  </p-autocomplete>
  <label>
    {{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
@if (control().invalid && control().touched) {
  @if (control().hasError('required')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
  }
  @if (control().hasError('email')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.email' | translate }}</p-message>
  }
}
